/* Livli homepage motion: reveal-on-scroll, scroll-driven animations and the scroll-scrubbed hero film.
   - Scroll animations (captions, turning can, step cards) are driven here, so they work on every
     browser, including iPhones on older iOS that can't do CSS scroll timelines.
   - The film is the video wherever it can play. Phones that refuse it (iPhone Low Power Mode) get
     image frames (livli-frames-01..10.webp) drawn on a canvas instead.
   Safe to load once per page; re-initialises when you edit sections in the theme editor. */
(function () {
  if (window.__livliHome) return;
  window.__livliHome = true;
  var html = document.documentElement;
  html.classList.add('lv-js');
  var reduce = window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;
  var me = document.currentScript;
  var assetBase = me && me.src ? me.src.replace(/livli-home\.js.*$/, '') : '';
  if (!reduce) html.classList.add('lv-sda');

  /* ---------- reveal on scroll ---------- */
  var io = ('IntersectionObserver' in window) ? new IntersectionObserver(function (entries) {
    entries.forEach(function (e) {
      if (e.isIntersecting) { e.target.classList.add('is-in'); io.unobserve(e.target); }
    });
  }, { rootMargin: '0px 0px -12% 0px', threshold: 0.15 }) : null;

  function initReveals(root) {
    var els = (root || document).querySelectorAll('.lv-rv:not(.is-in)');
    els.forEach(function (el) { if (io && !reduce) io.observe(el); else el.classList.add('is-in'); });
  }

  /* ---------- helpers ---------- */
  function clamp(v) { return v < 0 ? 0 : v > 1 ? 1 : v; }
  function vh() { return window.innerHeight || html.clientHeight; }
  /* "contain" progress: 0 when the section's top reaches the top of the screen, 1 when its bottom reaches the bottom */
  function containProgress(el) {
    var r = el.getBoundingClientRect(), range = r.height - vh();
    return range > 0 ? clamp(-r.top / range) : 0;
  }
  function translateY(el) {
    var t = getComputedStyle(el).transform;
    if (!t || t === 'none') return 0;
    var m = t.match(/matrix(3d)?\(([^)]+)\)/);
    if (!m) return 0;
    var v = m[2].split(',');
    return parseFloat(m[1] ? v[13] : v[5]) || 0;
  }
  /* "cover" progress: 0 when the element enters at the bottom, 1 when it leaves at the top (ignores its own animation) */
  function coverProgress(el) {
    var r = el.getBoundingClientRect(), h = vh(), top = r.top - translateY(el);
    return clamp((h - top) / (h + r.height));
  }
  var LV_ANIM = /^lv(Cap\d|Turn|SpinBg|Step)$/;
  function setP(el, p) {
    if (!el) return;
    p = clamp(p);
    var key = p.toFixed(4);
    if (el.__lvP === key) return;
    el.__lvP = key;
    if (el.getAnimations) {
      /* set the paused animation's position directly */
      el.getAnimations().forEach(function (a) { if (LV_ANIM.test(a.animationName || '')) a.currentTime = p * 999; });
    } else {
      /* very old browsers: scrub with a negative delay instead */
      el.style.setProperty('--lv-d', (-p * 0.999).toFixed(4) + 's');
    }
  }

  /* ---------- scroll-driven animations ---------- */
  var heroes = [], spins = [], cards = [];
  function initScrollAnims() {
    heroes = Array.prototype.slice.call(document.querySelectorAll('.lv-vhero'));
    spins = Array.prototype.slice.call(document.querySelectorAll('.lv-spin'));
    cards = Array.prototype.slice.call(document.querySelectorAll('.lv-step-card'));
  }
  function updateScrollAnims() {
    heroes.forEach(function (sec) {
      var p = containProgress(sec);
      sec.querySelectorAll('.lv-cap').forEach(function (c) { setP(c, p); });
    });
    spins.forEach(function (sec) {
      var p = containProgress(sec);
      setP(sec, p);
      setP(sec.querySelector('.lv-cyl'), p);
    });
    cards.forEach(function (c) { setP(c, coverProgress(c)); });
  }

  /* ---------- scroll-scrubbed film ----------
     The video is used everywhere it can play. If a phone refuses to load it (iPhone Low Power Mode),
     the film switches to image frames (livli-frames-01..10.webp, 16 frames each) drawn on a canvas. */
  var SHEETS = 10, PER = 16, COLS = 4, FW = 800, FH = 716, FRAMES = SHEETS * PER;
  var phone = window.matchMedia ? window.matchMedia('(max-width: 860px)') : { matches: false };
  var films = [];

  function filmProgress(f) {
    var r = f.sec.getBoundingClientRect();
    var range = r.height - (f.stick ? f.stick.offsetHeight : vh());
    return range > 0 ? clamp(-r.top / range) : 0;
  }

  function useFrames(f) {
    if (f.videoFailed) return;
    f.videoFailed = true; /* stop seeking the video so its poster stays up while frames load */
    if (!phone.matches) return;
    var base = f.sec.getAttribute('data-frames-base') || assetBase;
    if (!base || !window.HTMLCanvasElement) return;
    var canvas = document.createElement('canvas');
    canvas.className = 'lv-vvid lv-vcanvas';
    canvas.setAttribute('aria-hidden', 'true');
    f.vid.parentNode.insertBefore(canvas, f.vid.nextSibling);
    f.canvas = canvas;
    f.ctx = canvas.getContext('2d');
    f.sheets = [];
    function load(n) {
      if (n >= SHEETS) return;
      var img = new Image();
      img.decoding = 'async';
      img.onload = function () {
        img.__ok = true; f.sheets[n] = img;
        if (n === 0) { f.framesOn = true; f.sec.classList.add('lv-frames-on'); }
        f.last = -1; tick();
        load(n + 1);
      };
      img.onerror = function () { if (n === 0 && canvas.parentNode) canvas.parentNode.removeChild(canvas); };
      img.src = base + 'livli-frames-' + (n < 9 ? '0' : '') + (n + 1) + '.webp';
    }
    load(0);
  }

  function drawFrame(f, idx, alpha, cw, ch) {
    var s = Math.floor(idx / PER);
    while (s >= 0 && !(f.sheets[s] && f.sheets[s].__ok)) { s--; idx = s * PER + PER - 1; }
    if (s < 0) return;
    var k = idx - s * PER, sx = (k % COLS) * FW, sy = Math.floor(k / COLS) * FH;
    var scale = Math.max(cw / FW, ch / FH), dw = FW * scale, dh = FH * scale;
    f.ctx.globalAlpha = alpha;
    f.ctx.drawImage(f.sheets[s], sx + 1, sy + 1, FW - 2, FH - 2, (cw - dw) / 2, (ch - dh) * 0.4, dw, dh);
  }

  function renderFrames(f, p) {
    var c = f.canvas, dpr = Math.min(2, window.devicePixelRatio || 1);
    var cw = Math.round(c.clientWidth * dpr), ch = Math.round(c.clientHeight * dpr);
    if (!cw || !ch) return;
    var x = p * (FRAMES - 1), key = Math.round(x * 40) + ':' + cw + 'x' + ch;
    if (key === f.last) return;
    f.last = key;
    if (c.width !== cw || c.height !== ch) { c.width = cw; c.height = ch; }
    var ctx = f.ctx, i0 = Math.floor(x), a = x - i0;
    ctx.globalAlpha = 1;
    ctx.fillStyle = '#FCF9EA';
    ctx.fillRect(0, 0, cw, ch);
    drawFrame(f, i0, 1, cw, ch);
    if (a > 0.04 && i0 + 1 < FRAMES) drawFrame(f, i0 + 1, a, cw, ch);
    ctx.globalAlpha = 1;
  }

  function initFilms(root) {
    (root || document).querySelectorAll('[data-lv-film]').forEach(function (sec) {
      if (sec.__lvFilm) return;
      var vid = sec.querySelector('video');
      if (!vid) return;
      sec.__lvFilm = true;
      var f = { sec: sec, vid: vid, stick: sec.querySelector('.lv-vstick'), last: -1 };
      vid.muted = true;
      vid.setAttribute('muted', '');
      if (sec.getAttribute('data-mode') === 'play') {
        /* plays once by itself and holds on the last frame; if the phone blocks it, the poster stays */
        f.playMode = true;
        var started = false;
        var go = function () {
          if (started && (vid.ended || !vid.paused)) return;
          var pp = vid.play();
          if (pp && pp.then) pp.then(function () { started = true; }).catch(function () {});
        };
        go();
        vid.addEventListener('loadeddata', go);
        vid.addEventListener('canplay', go);
        vid.addEventListener('playing', function () { started = true; });
        /* phones in Low Power or Low Data mode block autoplay until the first tap or scroll */
        var kick = function () {
          if (!started && vid.paused && !vid.ended) go();
          if (started) ['touchend', 'click', 'scroll'].forEach(function (ev) { window.removeEventListener(ev, kick); });
        };
        ['touchend', 'click', 'scroll'].forEach(function (ev) { window.addEventListener(ev, kick, { passive: true }); });
        films.push(f);
        return;
      }
      vid.addEventListener('loadedmetadata', tick);
      /* phones get an all-keyframe copy of the film (livli-hero-mobile.mp4), so every scroll position lands on a sharp frame instantly */
      var orig = vid.getAttribute('src');
      if (phone.matches && assetBase && !sec.hasAttribute('data-custom-video')) {
        f.intra = true;
        vid.src = assetBase + 'livli-hero-mobile.mp4';
      }
      function prime() {
        var pr;
        try { pr = vid.play(); } catch (e) { useFrames(f); return; }
        if (pr && pr.then) pr.then(function () { vid.pause(); tick(); }).catch(function (e) {
          if (!e || e.name !== 'AbortError') useFrames(f);
        });
      }
      vid.addEventListener('error', function () {
        if (f.intra) { f.intra = false; vid.src = orig; vid.load(); prime(); return; } /* phone copy missing: use the main film */
        useFrames(f);
      });
      /* wake the video up (phones only load it after play); if the phone says no, use the frames */
      prime();
      setTimeout(function () { if (vid.readyState < 2) useFrames(f); }, 6000);
      films.push(f);
    });
    tick();
  }

  function updateFilms() {
    films.forEach(function (f) {
      if (f.playMode || !document.body.contains(f.sec)) return;
      var p = filmProgress(f);
      if (f.videoFailed) {
        if (f.framesOn) renderFrames(f, p);
        return;
      }
      var d = f.vid.duration;
      if (d && isFinite(d) && f.vid.readyState >= 1) {
        f.target = p * (d - 0.05);
        if (f.shown == null) f.shown = f.target;
        smooth(f);
      }
    });
  }

  /* glide toward the scroll position instead of jumping, and never queue a new seek while one is still decoding */
  function smooth(f) {
    if (f.raf) return;
    f.raf = requestAnimationFrame(function step() {
      f.raf = 0;
      var v = f.vid, gap = f.target - f.shown;
      f.shown = Math.abs(gap) < 0.004 ? f.target : f.shown + gap * 0.24;
      if (!v.seeking && Math.abs(v.currentTime - f.shown) > 0.02) {
        if (f.intra && v.fastSeek) v.fastSeek(f.shown); else v.currentTime = f.shown;
      }
      if (Math.abs(f.target - f.shown) > 0.004 || v.seeking) f.raf = requestAnimationFrame(step);
    });
  }

  /* ---------- loop ---------- */
  var ticking = false;
  function update() {
    ticking = false;
    if (!reduce) { updateScrollAnims(); updateFilms(); }
  }
  function tick() { if (!ticking) { ticking = true; requestAnimationFrame(update); } }
  window.addEventListener('scroll', tick, { passive: true });
  window.addEventListener('resize', function () { films.forEach(function (f) { f.last = -1; }); tick(); });
  window.addEventListener('load', tick);

  function initAll(root) {
    initReveals(root);
    if (reduce) (root || document).querySelectorAll('[data-lv-film][data-mode="play"] video').forEach(function (v) { v.removeAttribute('autoplay'); v.pause(); });
    if (!reduce) { initScrollAnims(); initFilms(root); }
    tick();
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', function () { initAll(); });
  else initAll();

  /* theme editor: re-run when a section is added or changed */
  document.addEventListener('shopify:section:load', function (e) { initAll(e.target); });
})();
